import { render } from "./ArchiveApprovalPendingCases.vue?vue&type=template&id=4304b508"
import script from "./ArchiveApprovalPendingCases.vue?vue&type=script&lang=js"
export * from "./ArchiveApprovalPendingCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pendingCases/ArchiveApprovalPendingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4304b508"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4304b508', __exports__)) {
    console.log('reload')
    api.reload('4304b508', __exports__)
  }
  
  module.hot.accept("./ArchiveApprovalPendingCases.vue?vue&type=template&id=4304b508", () => {
    console.log('re-render')
    api.rerender('4304b508', render)
  })

}


export default __exports__